import type { TrajectoryWidgetStateParams } from '@repo/go-widgets/trajectory';

import type { TTrajectoryPlanOrFact } from './TrajectoryWidget.entity';

export function parseTrajectoryWidgetInternalState(state: object): {
  wellId: number | null;
  wellboreId: number | null;
  trajectoryId: number | null;
  planOrFact: TTrajectoryPlanOrFact;
  stateParams: TrajectoryWidgetStateParams;
} {
  let wellId: number | null = null;
  let wellboreId: number | null = null;
  let trajectoryId: number | null = null;
  let planOrFact: TTrajectoryPlanOrFact = 'fact';
  let stateParams: TrajectoryWidgetStateParams = {};

  if ('wellId' in state && typeof state.wellId === 'number') {
    wellId = state.wellId;
  }

  if ('wellboreId' in state && typeof state.wellboreId === 'number') {
    wellboreId = state.wellboreId;
  }

  if ('trajectoryId' in state && typeof state.trajectoryId === 'number') {
    trajectoryId = state.trajectoryId;
  }

  if ('planOrFact' in state && (state.planOrFact === 'plan' || state.planOrFact === 'fact')) {
    planOrFact = state.planOrFact;
  }

  if ('stateParams' in state && typeof state.stateParams === 'object' && state.stateParams) {
    stateParams = state.stateParams as TrajectoryWidgetStateParams;
  }

  return {
    wellId,
    wellboreId,
    trajectoryId,
    planOrFact,
    stateParams,
  };
}
